module.exports = __webpack_public_path__ + "img/resolve_after_en.0c61b1dc.svg";